import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import "./AboutEdit.css";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const AboutEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, mode } = location.state || {};
  const isEditMode = mode !== "edit";

  const [formData, setFormData] = useState({
    language: "",
    content: "",
  });

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (data) {
      setFormData({
        language: data?.language || "",
        content:
          data?.description ||
          "Kadugudappa is a community-driven platform created to bring people closer through the warmth and authenticity of homemade food. Our mission is to reduce food waste while empowering home chefs to share their extra meals with those who appreciate real, lovingly prepared dishes. We believe that food made in home kitchens carries stories, memories, and emotions that cannot be replicated elsewhere. Through Kadugudappa, users can discover fresh meals prepared in their neighborhood, support local home cooks, and enjoy the comfort of homemade flavors anytime. By connecting households with surplus food to individuals seeking affordable, fresh, and trustworthy meals, Kadugudappa is building a sustainable ecosystem rooted in sharing, compassion, and responsibility. Every dish served through our platform not only satisfies hunger but also strengthens community bonds, making food a medium of kindness and connection.",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    try {
      if (!data?.id) return;
      console.log("Saved:", formData);
      let payload = {
        id: data.id,
        description: formData.content || "",
      };
      let res = await post(URLS.ABOUT_EDIT, payload);
      if (res?.status === "success") {
        toast.success(res?.message || "Saved successfully");
        setIsEditing(false);
      } else {
        toast.error(res?.message || "Failed to save");
      }
    } catch (error) {
      console.error("Error saving about content:", error);
      toast.error(error?.message || "An error occurred");
    }
  };

  return (
    <>
      <PageHeader
        title="About Us"
        showBackButton={true}
        onBackClick={() => navigate(-1)}
      />
      <div className="about-edit-container">
        <div className="about-edit-form">
          <h3 className="about-language-title">
            Kadugudappa ({formData?.language || "N/A"})
          </h3>

          <div className="about-content-wrapper">
            <textarea
              name="content"
              value={formData?.content || ""}
              onChange={handleChange}
              disabled={!isEditing}
              readOnly={!isEditing}
              className="about-textarea"
            />
          </div>

          <div className="form-actions">
            {!isEditing ? (
              <button type="button" className="btn-edit" onClick={handleEdit}>
                Edit
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </button>
                <button type="button" className="btn-save" onClick={handleSave}>
                  Save
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutEdit;
